// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"0b7b50b9","314":"0195ab0d","409":"ef77d48a","444":"b7357aff","445":"7ae66313","492":"20719720","602":"5403674f","653":"a332b9c1","931":"dbe26c88"}[chunkId] + ".chunk.js";
};